"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { procedure } from "../../../../public/images/measurement-service";
import { processMeasurment } from "../../../../public/images/service";

const ProcessInfo = () => {
  const t = useTranslations("measurementService.processInfo");

  return (
    <div className="gs--page-column pt-8 pb-16">
      <div className="flex flex-col">
        <FeatureHighlight
          src={procedure}
          alt={"Verkaufsoptimierter Grundriss Detail"}
          title={t("title")}
          text={t("text")}
          subText={t("subText")}
        />
        <Image
          className="mt-5"
          src={processMeasurment}
          alt={"Ablauf Aufmass-Service"}
          loading="lazy"
        />

        {/* List */}
        <div className="text-primary mt-8 flex flex-col gap-1">
          <span>1. {t("step")}</span>
          <span>2. {t("step2")}</span>
          <span>3. {t("step3")}</span>
          <span>4. {t("step4")}</span>
          <span>5. {t("step5")}</span>
          <span>6. {t("step6")}</span>
        </div>
      </div>
    </div>
  );
};

export default ProcessInfo;
